import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
export var updateAsset = function (object, organisationId, assetId) {
    var url = applyPathVariables(EndPoints.ORGANISATION_ASSET_UPDATE, { organisationId: organisationId, assetId: assetId });
    var request = new Request({
        method: Methods.PUT,
        url: url,
        data: object,
        withCredentials: true,
    });
    return request.execute();
};
